import React from "react";
import cx from "classnames";
import { Button } from "reactstrap";
import { useHistory } from "react-router";

import ImgBg from "../assets/images/Mint_POAP.svg";
import CodiaxHeader from "../CodiaxHeader/CodiaxHeader";

import s from "./CodiaxMintPage.module.scss";
import AppConfig from "../../../../AppConfig";

export default function CodiaxMintPage() {
	const history = useHistory();

	const claim = 1123;
	const mintUrl = `${AppConfig.POAP_URL}/${claim}`;

	const onMint = () => {
		window.open(mintUrl, "_blank");

		history.push("/codiax/data");
	};

	return (
		<div className={s.root}>
			<CodiaxHeader showHelp hideAvatar />

			<div className={s.content}>
				<div className={s.infoContainer}>
					<p className={s.title}>mint POAP</p>
					<p className={s.description}>
						click the button to mint your POAP & access the CODIAX 2022
						Weavechain Workshop
					</p>
				</div>

				<div className={s.logo}>
					<img src={ImgBg} alt="logo" />
				</div>

				<Button
					className={cx(s.button, "btn-default dark")}
					color="primary"
					onClick={onMint}
				>
					Mint POAP
				</Button>
			</div>
		</div>
	);
}
